module.exports = __webpack_public_path__ + "static/icba-thinktech-group-7a65c10db04eb22fb66f63d12c624ffc.jpg";